import { render, staticRenderFns } from "./PermissManage.vue?vue&type=template&id=12d549a8&"
import script from "./PermissManage.vue?vue&type=script&lang=js&"
export * from "./PermissManage.vue?vue&type=script&lang=js&"
import style0 from "./PermissManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports